import { Directive, TemplateRef } from '@angular/core';

interface Context<T> {
  $implicit?: T; // current item exposed as implicit value
  index?: number;
}

@Directive({
  selector: '[appCollapseCell]',
  standalone: false,
})
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class CollapseCellDirective<T> {
  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public templateRef: TemplateRef<any>,
  ) {}

  static ngTemplateContextGuard<T>(
    dir: CollapseCellDirective<T>,
    //  eslint-disable-next-line @typescript-eslint/no-explicit-any
    ctx: any,
  ): ctx is Context<T> {
    return true;
  }
}
